export const createEntity = (() => {
  let id = 1;

  return ({
    automated = true,
    channel = 'brokerage',
    is_site = false,
    is_company = true,
    is_division = false,
    status = 'live',
  } = {}) => ({
    automated,
    channel,
    code: `code_${id}`,
    name: `Entity ${id}`,
    id: id++,
    is_site,
    is_company,
    is_division,
    status,
  });
})();
